import React from "react";
import AnimationTrigger from "./atoms/animationTrigger";
import Top from "./top";
import About from "./about";
import Header from "./header";
import Rooms from "./rooms";
import Service from "./service";
import Schedule from "./schedule";
import Access from "./access";
import News from "./news";
import Address from "./address";
import Contact from "./contact";
import Footer from "./footer";
import Burger from "./burger";

function App() {
  return (
    <React.Fragment>
      <Header />
      <Burger />
      <Top />
      <AnimationTrigger>
        <About />
      </AnimationTrigger>
      <AnimationTrigger>
        <Rooms />
      </AnimationTrigger>
      <AnimationTrigger>
        <Service />
      </AnimationTrigger>
      <AnimationTrigger>
        <Schedule />
      </AnimationTrigger>
      <AnimationTrigger>
        <Access />
      </AnimationTrigger>
      <AnimationTrigger>
        <News />
      </AnimationTrigger>
      <AnimationTrigger>
        <Address />
      </AnimationTrigger>
      <AnimationTrigger>
        <Contact />
      </AnimationTrigger>
      <Footer />
    </React.Fragment>
  );
}

export default App;
